export default {
    slug: 'gohighlevel',
    ability: 'gohighlevel',
    routes: [],
    integrationRoutes: [
        {
            path: 'gohighlevel',
            name: 'settings-gohighlevel',
            component: () => import('@modules/SyncGhl/Resources/js/pages/GhlSettings.vue'),
            props: true
        }
    ],
    integrationTabs: () => [
        {
            title: i18n.t('Go High Level'),
            icon: 'sync',
            route: 'settings-gohighlevel',
            position: 40
        }
    ]
};
